import script from "./ActionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ActionMenu.vue?vue&type=style&index=0&id=18c95935&lang=scss"

const __exports__ = script;

export default __exports__